import { MultisidebarItem } from '@/store/multisidebar/types';
import { ItemViewModel } from '@/definitions/view-models';
import { Counter } from '@/api';

export default async function ({ model }: MultisidebarItem<ItemViewModel<Counter>>) {
  return { label: model.item?.name || '' };
}
